<template>
  <v-card flat>
    <v-card-text>
      <input type="file" @change="fileUpdate" />
      <v-checkbox
        :label="$t('user.import.labels.sendEmail')"
        v-model="sendEmail"
      />
    </v-card-text>
    <v-divider />
    <v-card-row actions>
      <v-btn class="ml-2" @click.native.stop="submit()" primary light ripple>
        {{ $t("user.import.save") }}
      </v-btn>
    </v-card-row>
  </v-card>
</template>

<script>
import User from '@/api/user'
export default {
  data () {
    return {
      file: null,
      sendEmail: true
    }
  },
  methods: {
    fileUpdate (e) {
      this.file = e.currentTarget.files[0]
    },
    async submit () {
      await User.importUsers({
        file: this.file,
        email_notification: this.sendEmail
      })
      this.$emit('imported')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/ImportForm.vue